var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2226 2.2688L12.3306 2.37917L12.4378 2.26812L13.7825 0.87546C13.9626 0.688954 14.2294 0.635806 14.4628 0.735196C14.6954 0.834237 14.85 1.07248 14.85 1.34038V5.62549C14.85 5.99289 14.5664 6.27895 14.2242 6.27895H13.9494H10.0865C9.83591 6.27895 9.60574 6.12371 9.50825 5.87814C9.40979 5.63009 9.46383 5.34803 9.64484 5.16057L9.64496 5.16044L10.9736 3.78117L11.0748 3.67605L10.9725 3.57196C8.88982 1.45298 5.54394 1.46333 3.47461 3.60639C1.39812 5.75685 1.39812 9.24025 3.47461 11.3907C5.55395 13.5441 8.92642 13.5441 11.0058 11.3907C11.3509 11.0333 11.9092 11.0333 12.2543 11.3907C12.6023 11.7511 12.6023 12.3385 12.2543 12.6989C9.48477 15.567 4.99883 15.567 2.22929 12.6989C-0.543096 9.8277 -0.543096 5.17275 2.22929 2.3016L2.22935 2.30154C4.98613 -0.556726 9.44992 -0.566639 12.2226 2.2688Z",
    fill: "#373939",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.b587d937859e76e6de48b7b9fe8b295f.svg";
export { ForwardRef as ReactComponent };